import { TestResults, FvcTestRepeatabilitySummary, PefTestRepeatabilitySummary } from "../../PulmonaryFunctionTests/Shared/PFTAPITypes";
import { ParameterTypeName } from "./ParameterTypes";
import { SelectedFixedCommentMeta } from "./FixedComments/apiTypes";
import { FvcAnalysisSet, FvcSession, PefAnalysisSet, PefSession } from "webportalclient";

export function MapFvcTestAcceptabilitySummaries(testResults: TestResults[]): Array<FvcTestRepeatabilitySummary> {
    return testResults.map(tr => {
        return {
            TestId: tr.TestId,
            Accepted: tr.OverreaderAcceptability,
            Fvc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_FVC).Value,
            Fev1: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_FEV1).Value,
            Pef: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_PEFMIN).Value,
            Fef2575: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_FEF2575).Value,
            Fev1Fvc: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_FEV1FVC).Value,
            Fev6: tr.TestParameters.find(tp => tp.ParameterType === ParameterTypeName.PARAM_FEV6).Value
        } as FvcTestRepeatabilitySummary;
    })
}

export function MapFvcTestAcceptabilitySummariesForAnalysisSet(analysisSet: FvcAnalysisSet, session: FvcSession): Array<FvcTestRepeatabilitySummary> {
    return analysisSet.tests.filter(ast => session.tests.map(t => t.id).includes(ast.testId)).map(ast => {
        return {
            TestId: ast.testId,
            Accepted: ast.accepted,
            Fvc: session.tests.find(t => t.id === ast.testId).fvc,
            Fev1: session.tests.find(t => t.id === ast.testId).fev1,
            Pef: session.tests.find(t => t.id === ast.testId).pefMin,
            Fef2575: session.tests.find(t => t.id === ast.testId).fef2575,
            Fev1Fvc: session.tests.find(t => t.id === ast.testId).fev1Fvc,
            Fev6: session.tests.find(t => t.id === ast.testId).fev6
        } as FvcTestRepeatabilitySummary;
    })
}

export function MapPefTestAcceptabilitySummariesForAnalysisSet(analysisSet: PefAnalysisSet, siteAnalysisSet: PefAnalysisSet, session: PefSession): Array<PefTestRepeatabilitySummary> {
    const setTests = analysisSet.tests.length > 0 ? analysisSet.tests : siteAnalysisSet.tests;


    return setTests.filter(ast => session.tests.map(t => t.id).includes(ast.testId)).map(ast => {
        return {
            TestId: ast.testId,
            Accepted: ast.accepted,
            PefMin: session.tests.find(t => t.id === ast.testId).pefMin,
            PefSec: session.tests.find(t => t.id === ast.testId).pefSec,
        } as PefTestRepeatabilitySummary;
    })
}

export interface SpirometryFixedComment extends SelectedFixedCommentMeta {

}
